var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAoisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_6740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7L24.5 11.5M26.1022 16.5L24 24M20 27H12.5M8 24L5.5 16.5M7 12L13.5 7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.66667C18.3333 4.95942 18.0524 4.28115 17.5523 3.78105C17.0522 3.28095 16.3739 3 15.6667 3C14.9594 3 14.2811 3.28095 13.781 3.78105C13.281 4.28115 13 4.95942 13 5.66667C13 6.37391 13.281 7.05219 13.781 7.55229C14.2811 8.05238 14.9594 8.33333 15.6667 8.33333C16.3739 8.33333 17.0522 8.05238 17.5523 7.55229C18.0524 7.05219 18.3333 6.37391 18.3333 5.66667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 26.6667C25.3333 25.9594 25.0524 25.2811 24.5523 24.781C24.0522 24.281 23.3739 24 22.6667 24C21.9594 24 21.2811 24.281 20.781 24.781C20.281 25.2811 20 25.9594 20 26.6667C20 27.3739 20.281 28.0522 20.781 28.5523C21.2811 29.0524 21.9594 29.3333 22.6667 29.3333C23.3739 29.3333 24.0522 29.0524 24.5523 28.5523C25.0524 28.0522 25.3333 27.3739 25.3333 26.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 13.6667C7.33333 12.9594 7.05238 12.2811 6.55228 11.781C6.05219 11.281 5.37391 11 4.66667 11C3.95942 11 3.28115 11.281 2.78105 11.781C2.28095 12.2811 2 12.9594 2 13.6667C2 14.3739 2.28095 15.0522 2.78105 15.5523C3.28115 16.0524 3.95942 16.3333 4.66667 16.3333C5.37391 16.3333 6.05219 16.0524 6.55228 15.5523C7.05238 15.0522 7.33333 14.3739 7.33333 13.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 26.6667C12.3333 25.9594 12.0524 25.2811 11.5523 24.781C11.0522 24.281 10.3739 24 9.66667 24C8.95942 24 8.28115 24.281 7.78105 24.781C7.28095 25.2811 7 25.9594 7 26.6667C7 27.3739 7.28095 28.0522 7.78105 28.5523C8.28115 29.0524 8.95942 29.3333 9.66667 29.3333C10.3739 29.3333 11.0522 29.0524 11.5523 28.5523C12.0524 28.0522 12.3333 27.3739 12.3333 26.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 13.6667C29.3333 12.9594 29.0524 12.2811 28.5523 11.781C28.0522 11.281 27.3739 11 26.6667 11C25.9594 11 25.2811 11.281 24.781 11.781C24.281 12.2811 24 12.9594 24 13.6667C24 14.3739 24.281 15.0522 24.781 15.5523C25.2811 16.0524 25.9594 16.3333 26.6667 16.3333C27.3739 16.3333 28.0522 16.0524 28.5523 15.5523C29.0524 15.0522 29.3333 14.3739 29.3333 13.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_6740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoisIcon);
export default __webpack_public_path__ + "static/media/aois-icon.0ed4f743c491bfeed59fb83fe82b1881.svg";
export { ForwardRef as ReactComponent };